import { defaultDataIdFromObject, InMemoryCacheConfig } from '@apollo/client';
import typePolicies from './typePolicies';

const cacheConfig: InMemoryCacheConfig = {
    dataIdFromObject(responseObject) {
        // eslint-disable-next-line
        const typename = responseObject.__typename;
        if (!typename) {
            return defaultDataIdFromObject(responseObject);
        }

        switch (typename) {
            // Add cases
            case 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa':
                return `${typename}:${responseObject.plano_padrao_id}`;
            case `navia_dashboards_caudais_diarios_dados`:
                return `${typename}:${responseObject.id_municipio}`;
            case `navia_dashboards_diagnostico_roturas_tipos_infraestrutura`:
                return `${typename}:${responseObject.tipo_infraestrutura_id}`;
            case `navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc`:
                return `navia_dashboards_diagnostico_roturas_tipos_infraestrutura:${responseObject.tipo_infraestrutura_id}`;
            // default case
            default:
                return `${typename}:${responseObject.id}`;
        }
    },
    typePolicies,
};

export default cacheConfig;
